import React from 'react';
import { ProjectByIdQuery_project } from '@frontend/app/queries/types/ProjectByIdQuery';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { SidebarLayout } from '../components/SidebarLayout';
import { AllApplications } from './AllApplications';
import { PulseTemplate } from './PulseTemplate';
import { RecruitmentProvider } from './RecruitmentContext';

type TProps = {
  project: ProjectByIdQuery_project;
};

export const RecruitmentPage = (props: TProps) => {
  const { project } = props;

  const { path } = useRouteMatch();

  const sections = [
    {
      id: 'application-page',
      label: 'Application Page',
      component: <AllApplications projectId={project.id} />,
    },
  ];

  return (
    <Switch>
      <Route
        path={`${path}/recruitment/:templateId`}
        render={() => (
          <RecruitmentProvider>
            <PulseTemplate />
          </RecruitmentProvider>
        )}
      />
      <Route
        path={`${path}/recruitment`}
        render={() => (
          <SidebarLayout
            sections={sections}
            activeSectionId="application-page"
            onlyShowActiveSection
            mainContentClassName="mx-[0px] w-full p-0"
            mainContentWrapperClassName="p-0"
          />
        )}
      />
    </Switch>
  );
};
